import {Box, MenuItem} from "@mui/material";
import DivContainerBody from "../../../../components/DivContainerBody";
import {CustomCheckbox} from "../../../../components/CustomCheckbox";
import {timeZone} from "../../../../enums/timeZoneEnum";
import {CustomSelectAndChildren} from "../../../../components/CustomSelectAndChildren";
import {DEVICE_MODEL_NAME, STEPS_CREATE_DEVICE,DISABLE_CAMERA_ANTENNA} from "../Model/Model";
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import {CleanIcon} from "../../../../components/buttons/IconButtons";

/**
 * Provides a group of checkboxes and form fields for configuring device display options,
 * access controls, and hardware features. Options availability is dynamically controlled
 * based on device type using predefined group arrays.
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @param {Object} data - Current device configuration data
 * @param {Function} handleChange - Universal change handler for all form inputs
 * @param {Function} t - Translation function for internationalization
 * @param {boolean} emptyFields - Flag indicating validation state for required fields
 * @param id - id by the device
 * @param handleClear - functions to clear the inputs
 * @returns {JSX.Element}
 * @constructor
 */

const SectionCreateDeviceOptions = ({data, handleChange, t, id, handleClear}) => {

    const enableGroup2 = [
        DEVICE_MODEL_NAME.TELPO_F10,
        DEVICE_MODEL_NAME.ARATEK_BM7550,
        DEVICE_MODEL_NAME.ARATEK_BA8300,
        DEVICE_MODEL_NAME.ARATEK_BD8500
    ];
    const enablePrinter = [
        DEVICE_MODEL_NAME.TELPO_K5,
        DEVICE_MODEL_NAME.TELPO_K10];

    return (
        <DivContainerBody>
            <div className={"row"}>
                <div className='d-flex justify-content-end col-12 mb-2'>
                    {id !== undefined ? (
                        ''
                    ) : (
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_cud_clean_all_inputs'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={() => {
                                handleClear(STEPS_CREATE_DEVICE.OPTIONS.INDEX);
                            }}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    )}
                </div>
                <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-0">
                    <CustomCheckbox
                        marginbutton={true}
                        id="cb_cud_show_logos"
                        checked={data?.options?.showLogo}
                        value={data?.options?.showLogo}
                        onChange={(evt) => {
                            handleChange(evt, 'options');
                        }}
                        labelId="lbl_cud_showLogos"
                        label="show_logos"
                        trans="show_logos"
                        name="showLogo"
                        disabled={true}
                    />
                </Box>
                <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <CustomCheckbox
                        marginbutton={true}
                        id="cb_cud_show_user_list"
                        checked={data?.options.showUserList}
                        onChange={(evt) => {
                            handleChange(evt, 'showUserList', 'options');
                        }}
                        labelId={"lbl_cud_showLogos"}
                        label={"show_user_list"}
                        trans={"show_user_list"}
                        name={"showUserList"}
                        disabled={DISABLE_CAMERA_ANTENNA.includes(data?.data?.deviceType)}
                    />
                </Box>
                <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <CustomCheckbox
                        marginbutton={true}
                        id="cb_cud_synchorize_selfies"
                        checked={data?.options?.synchorizeSelfies}
                        onChange={(evt) => {
                            handleChange(evt, 'synchorizeSelfies', 'options');
                        }}
                        labelId={"lbl_cud_synchorizeSelfies"}
                        label={"synchronize_photographs"}
                        trans={"synchronize_photographs"}
                        name={"synchorizeSelfies"}
                        disabled={DISABLE_CAMERA_ANTENNA.includes(data?.data?.deviceType)}
                    />
                </Box>
                <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <CustomCheckbox
                        id="cb_cud_play_sounds"
                        marginbutton={true}
                        checked={data?.options.playSounds}
                        onChange={(evt) => {
                            handleChange(evt, 'playSounds', 'options');
                        }}
                        labelId={"lbl_cud_playSounds"}
                        label={"playSound"}
                        trans={"playSound"}
                        name={"playSounds"}
                        disabled={DISABLE_CAMERA_ANTENNA.includes(data?.data?.deviceType)}
                    />
                </Box>
                <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <CustomCheckbox
                        marginbutton={true}
                        id="cb_cud_show_weapon"
                        checked={data?.options?.showWeapon}
                        onChange={(evt) => {
                            handleChange(evt, 'showWeapon', 'options');
                        }}
                        labelId={"cb_cud_showWeapon"}
                        label={"show_weapon"}
                        trans={"show_weapon"}
                        name={"showWeapon"}
                        disabled={true}
                    />
                </Box>
                <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <CustomCheckbox
                        marginbutton={true}
                        id="cb_cud_show_vehicles"
                        checked={data?.options?.showVehicle}
                        onChange={(evt) => {
                            handleChange(evt, 'showVehicle', 'options');
                        }}
                        labelId={"lbl_cud_showVehicle"}
                        label={"show_vehicle"}
                        trans={"show_vehicle"}
                        name={"showVehicle"}
                        disabled={true}
                    />
                </Box>
                <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <CustomCheckbox
                        marginbutton={true}
                        id="cb_cud_show_led"
                        checked={data?.options?.showLed}
                        onChange={(evt) => {
                            handleChange(evt, 'showLed', 'options');
                        }}
                        labelId={"lbl_cud_showLed"}
                        label={"show_led"}
                        trans={"turn_on_led"}
                        name={"showLed"}
                        disabled={!enableGroup2.includes(data?.data?.deviceType)}
                    />
                </Box>
                <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <CustomCheckbox
                        marginbutton={true}
                        id="cb_cud_show_access_dialog"
                        checked={data?.options?.showAccessDialog}
                        onChange={(evt) => {
                            handleChange(evt, 'showAccessDialog', 'options');
                        }}
                        labelId={"lbl_cud_showAccessDialog"}
                        label={"show_access_dialog"}
                        trans={"show_access_dialog"}
                        name={"showAccessDialog"}
                        disabled={DISABLE_CAMERA_ANTENNA.includes(data?.data?.deviceType)}
                    />
                </Box>
                <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <CustomCheckbox
                        marginbutton={true}
                        id="cb_cud_show_last_access"
                        checked={data?.options?.showLastAccess}
                        onChange={(evt) => {
                            handleChange(evt, 'showLastAccess', 'options');
                        }}
                        labelId={"lbl_cud_showLastAccess"}
                        label={"show_last_access"}
                        trans={"show_last_access"}
                        name={"showLastAccess"}
                        disabled={DISABLE_CAMERA_ANTENNA.includes(data?.data?.deviceType)}
                    />
                </Box>
                <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <CustomCheckbox
                        marginbutton={true}
                        className={"grid-checkall"}
                        id="cb_cud_printer"
                        checked={data?.options?.printer}
                        onChange={(evt) => {
                            handleChange(evt, 'printer', 'options');
                        }}
                        labelId={"lbl_cud_printer"}
                        label={"enable_printer"}
                        trans={"enable_printer"}
                        name={"printer"}
                        disabled={!enablePrinter.includes(data?.data?.deviceType)}
                    />
                </Box>
                <div className={"col-12 row mt-4 p-0"}>
                    <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <CustomSelectAndChildren
                            id="slt_cud_time_zone"
                            name="timeZoneValue"
                            trans="time_zone"
                            label="lbl_cud_time_zone"
                            showNoSelectionOption={false}
                            value={data?.options?.timeZoneValue}
                            onChange={(evt) => {
                                handleChange(evt, 'timeZoneValue', 'options');
                            }}
                            disabled={DISABLE_CAMERA_ANTENNA.includes(data?.data?.deviceType)}
                        >
                            {Object.entries(timeZone).map(([key, value]) => (
                                <MenuItem key={key} value={key}>
                                    {t(value)}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </Box>
                </div>
            </div>
        </DivContainerBody>
    );
};

export default SectionCreateDeviceOptions;
